<script>
import baseMixin from '@/mixins/baseMixin'
import EmptyStateBlock from '@/components/general/empty-state-block.vue'

export default {
  name: 'RegistrationFailureBlock',
  components: {
    EmptyStateBlock,
  },
  mixins: [baseMixin],
  props: {
    isRetrying: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <section>
    <EmptyStateBlock
      :description="$t('subBubbleAgreements.failedToLoadText')"
      border
    >
      <template v-slot:icon>
        <v-icon color="error" class="mb-5" x-large>
          mdi-close-circle-outline
        </v-icon>
      </template>
      <template v-slot:title>
        <h2 class="mb-8"> {{ $t('error.genericFailedToLoad') }} </h2>
      </template>
      <template v-slot:button>
        <section class="mt-4">
          <v-btn
            class="custom-elevation white--text"
            color="primary"
            large
            :loading="isRetrying"
            @click="$emit('retry')"
          >
            <v-icon left>mdi-cached</v-icon> {{ $t('general.retry') }}
          </v-btn>
        </section>
      </template>
    </EmptyStateBlock>
  </section>
</template>
